import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Table, TableHead, TableBody, TableCell, TableRow} from '@material-ui/core';
import {Paper} from '@material-ui/core';
import { formatDateTime } from '../../../../api/date';
import { SortableTable } from '../../../../components/SortableTable';

class ReportGuardTourList_ extends React.Component {

    tourStateName(state){

        switch(state){
            case 0: return 'All'
            case 1: return 'Started'
            case 2: return 'Paused'
            case 3: return 'Stopped'
        }
        return ''

    }

    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
              marginTop: 10
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            }
        }

        /**
         * 
attendDt: 1714629128517
​​​
dispatcherName: "All Dispatchers"
​​​
endDt: null
​​​
id: "a973f7fe-1bcd-4cd7-8511-189970cbcfc6"
​​​
name: "test tour"
​​​
pointName: "1"
​​​
pointState: 3
​​​
startDt: 1714629063347
​​​
state: 1
​​​
userName: "sda  12345"
         */


        let columns = [
            {
                label: t('TourName'),
                name: 'name',
                allowSort: true,
            },
            {
                label: t('Dispatcher'),
                name: 'dispatcherName',
                allowSort: true,
            },
            {
                label: t('User'),
                name: 'userName',
                allowSort: true,
            },

            {
                label: t('TourState'),
                name: 'state',
                eval: (val)=>(t(this.tourStateName(val))),
                allowSort: true,
                sortEval: (val)=>(t(this.tourStateName(val))),
            },
            {
                label: t('StartTime'),
                name: 'startDt',
                eval: (val)=>(formatDateTime(val, 'full_date')),
                allowSort: true,
            },
            {
                label: t('StopTime'),
                name: 'endDt',
                eval: (val)=>(formatDateTime(val, 'full_date')),
                allowSort: true,
            },
            {
                label: t('CheckpointName'),
                name: 'pointName',
                allowSort: true,
            },
            {
                label: t('CheckpointState'),
                name: 'pointState1',
                eval: (val, row)=>((row.pointState&1)?t('Attended'):t('NotAttended')),
                allowSort: true,
                sortEval: (val, row)=>((row.pointState&1)?t('Attended'):t('NotAttended')),
            },
            {
                label: t('Alerted'),
                name: 'pointState2',
                eval: (val, row)=>((row.pointState&2)?t('Alerted'):''),
                allowSort: true,
                sortEval: (val, row)=>((row.pointState&2)?t('Alerted'):''),
            },
            {
                label: t('AttendTime'),
                name: 'attendDt',
                eval: (val)=>(formatDateTime(val, 'full_date')),
                allowSort: true,
            }, 
        ]
        

        return(
            <Paper style={styles.paper}>

                <SortableTable
                    t={t}
                    rows={this.props.reportData.rows}
                    columns={columns}
                    version={this.props.reportData.version}
                />

                {/*

                <Table size="small">
                    
                    <TableHead>
                        <TableRow>
                            <TableCell style={styles.head}>{t('TourName')}</TableCell>
                            <TableCell style={styles.head}>{t('Dispatcher')}</TableCell>
                            <TableCell style={styles.head}>{t('User')}</TableCell>
                            <TableCell style={styles.head}>{t('TourState')}</TableCell>
                            <TableCell style={styles.head}>{t('StartTime')}</TableCell>
                            <TableCell style={styles.head}>{t('StopTime')}</TableCell>
                            
                            <TableCell style={styles.head}>{t('CheckpointName')}</TableCell>
                            <TableCell style={styles.head}>{t('CheckpointState')}</TableCell>

                            <TableCell style={styles.head}>{t('Alerted')}</TableCell>
                            <TableCell style={styles.head}>{t('AttendTime')}</TableCell>
                        </TableRow>
                    </TableHead>
                    
                    <TableBody>
                        {this.props.reportData.rows && this.props.reportData.rows.map((row,index)=>(
                            <TableRow key={index}>
                                <TableCell>
                                    {row.name}
                                </TableCell>
                                <TableCell>
                                    {row.dispatcherName}
                                </TableCell>
                                <TableCell>
                                    {row.userName}
                                </TableCell>
                                <TableCell>
                                    {t(this.tourStateName(row.state))}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(row.startDt, 'full_date')}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(row.endDt, 'full_date')}
                                </TableCell>
                                
                                <TableCell>
                                    {row.pointName}
                                </TableCell>
                                <TableCell>
                                    {(row.pointState&1)?t('Attended'):t('NotAttended')}
                                </TableCell>
                                <TableCell>
                                    {(row.pointState&2)?t('Alerted'):''}
                                </TableCell>
                                <TableCell>
                                    {formatDateTime(row.attendDt, 'full_date')}
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>
                </Table>
                */}
            </Paper>
        );

    }

}

export const ReportGuardTourList = withTranslation()(ReportGuardTourList_);